import { Link } from 'react-router';
import { useAuthStore } from '@auth/authStore';
import { buildScopedSearch } from '@hooks';
import { historyLocationKey } from '@entities';
import styles from './HistoryLink.module.css';

export default function HistoryLink({ siteId, assetId, componentCode, recordId, view = 'anomalies', children = 'View lifecycle history' }) {
  const companyId = useAuthStore(state => state.companyID);
  const completeLocation = Boolean(siteId && assetId);
  // Incomplete anomaly locations must remain discoverable from the fleet list.
  const scope = recordId && !completeLocation ? { siteId: null, assetId: null } : { siteId, assetId };
  const search = buildScopedSearch('', scope, {
    historyView: view, 'history.selected': recordId || null,
    'history.component': completeLocation && componentCode ? componentCode : null,
    'history.componentScope': completeLocation && componentCode ? historyLocationKey(siteId, assetId, companyId) : null,
  });
  return <Link className={styles.link} to={{ pathname: '/history', search: '?' + search }}>{children}</Link>;
}